import React from 'react';

function Tick(props) {
    const fill = props.fill;
    const className = props.className;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20" 
            height="20" 
            viewBox="0 0 20 20" 
            fill="none"
            className={className}
        >
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M17.7898 3.93077C18.0581 4.18286 18.0713 4.60477 17.8192 4.87312L7.48589 15.8731C7.36236 16.0046 7.1908 16.0804 7.0104 16.0832C6.83 16.0861 6.65617 16.0156 6.52859 15.8881L2.19526 11.5547C1.93491 11.2944 1.93491 10.8723 2.19526 10.6119C2.45561 10.3516 2.87772 10.3516 3.13807 10.6119L6.98503 14.4589L16.8474 3.96022C17.0995 3.69186 17.5214 3.67868 17.7898 3.93077Z" 
                fill={fill}
            />
        </svg>
    )
}

export default Tick;